// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs__TMyr2","tab":"tab__JgZVw","tab-selected":"tab-selected__2XvUw"};